@use "sass:string";
@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: relative;
    grid-column: span 6;
    aspect-ratio: 4 / 3;
    overflow: hidden;

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }

    &:has(a):not(:has(video)) {
        cursor: pointer;
    }
}

.media {
    position: absolute;
    inset: 0;

    img,
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.mediaWithOverlay {
    composes: media;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: var(--overlay-black-56);
        pointer-events: none;
        z-index: 1;
    }
}

.content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--spacer-16);
    padding: var(--spacer-80) var(--spacer-24);
    overflow: hidden;
    z-index: 2;
}

.measure {
    composes: content;
    visibility: hidden;
    pointer-events: none;
}

.clampedHeading {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

:export {
    sizes: string.unquote("(min-width: #{$mobile}) 50vw, 100vw");
}
